module.exports = __webpack_public_path__ + "img/home-clothing1.96896dbc.png";